<template>
    <div class="flex min-h-screen">
      <!-- Mobile Menu Button -->
      <div class="mobile-menu-button" @click="sidebarOpen = true">
        <font-awesome-icon icon="bars" />
      </div>

      <!-- Mobile Sidebar (Element UI Drawer) -->
      <el-drawer
        v-model="sidebarOpen"
        title=""
        :size="280"
        :direction="'ltr'"
        :show-close="true"
        class="mobile-drawer"
        :with-header="false"
      >
        <div class="mobile-sidebar-content">
          <!-- Mobile Sidebar Header -->
          <div class="mobile-sidebar-header">
            <div class="logo-section">
              <div class="logo-icon">
                <font-awesome-icon icon="chart-line" />
              </div>
              <h2 class="logo-text">Sky Cargo</h2>
            </div>
          </div>

          <!-- Mobile Navigation Menu -->
          <nav class="mobile-sidebar-nav">
            <ul class="mobile-nav-list">
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="chart-line" />
                  </span>
                  <span class="nav-text">Дашбоард</span>
                </router-link>
              </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/users" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="users" />
                  </span>
                  <span class="nav-text">Хэрэглэгч</span>
                </router-link>
              </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/banners" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="bullhorn" />
                  </span>
                  <span class="nav-text">Суртчилгаа</span>
                </router-link>
              </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/faqs" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="question-circle" />
                  </span>
                  <span class="nav-text">Түгээмэл асуулт</span>
                </router-link>
              </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/trackCodes" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="barcode" />
                  </span>
                  <span class="nav-text">Track Code</span>
                </router-link>
          </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/worker" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="user-tie" />
                  </span>
                  <span class="nav-text">Ажилтан</span>
                </router-link>
          </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/message" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="envelope" />
                  </span>
                  <span class="nav-text">Мессеж</span>
                </router-link>
          </li>
              <li v-if="checkPermissionsPage('admin')">
                <router-link to="/messageHistory" class="mobile-nav-item" @click="sidebarOpen = false">
                  <span class="nav-icon">
                    <font-awesome-icon icon="clock-rotate-left" />
                  </span>
                  <span class="nav-text">Мессеж түүх</span>
                </router-link>
          </li>
              <!-- Зардал цэс -->
              <li v-if="checkPermissionsPage('admin')" class="nav-group">
                <div
                  @click="showCostSubmenu = !showCostSubmenu"
                  class="mobile-nav-item nav-item-group"
                  :class="{ 'nav-item-active': isCostRoute || showCostSubmenu }"
                >
                  <span class="nav-icon">
                    <font-awesome-icon icon="dollar-sign" />
                  </span>
                  <span class="nav-text">Зардал</span>
                  <span class="nav-arrow">
                    <font-awesome-icon
                      :icon="showCostSubmenu ? 'chevron-down' : 'chevron-right'"
                      class="transition-transform duration-200"
                    />
                  </span>
                </div>

                <!-- Дэд цэс - Dynamic зардлын төрлүүд -->
                <transition name="slide-fade">
                  <ul v-show="showCostSubmenu" class="mobile-submenu">
                    <li>
                      <router-link to="/costs" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Бүх зардал</span>
                      </router-link>
          </li>
                    <li>
                      <router-link to="/costTypes" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Зардлын төрөл удирдах</span>
                      </router-link>
          </li>
                    <li>
                      <router-link to="/costs/transfer" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Салбар хооронд шилжүүлэлт</span>
                      </router-link>
          </li>
                    <li>
                      <router-link to="/costs/deliveries" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Хүргэлт</span>
                      </router-link>
          </li>
                    <li v-for="costType in costTypes" :key="costType.id">
                      <router-link :to="`/costs/${costType.id}`" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>{{ costType.name }}</span>
                      </router-link>
          </li>
                  </ul>
                </transition>
          </li>

              <!-- Тайлан цэс -->
              <li v-if="checkPermissionsPage('admin')" class="nav-group">
                <div
                  @click="showReportSubmenu = !showReportSubmenu"
                  class="mobile-nav-item nav-item-group"
                  :class="{ 'nav-item-active': isReportRoute || showReportSubmenu }"
                >
                  <span class="nav-icon">
                    <font-awesome-icon icon="chart-pie" />
                  </span>
                  <span class="nav-text">Тайлан</span>
                  <span class="nav-arrow">
                    <font-awesome-icon
                      :icon="showReportSubmenu ? 'chevron-down' : 'chevron-right'"
                      class="transition-transform duration-200"
                    />
                  </span>
                </div>

                <!-- Дэд цэс - Dynamic тайлангууд -->
                <transition name="slide-fade">
                  <ul v-show="showReportSubmenu" class="mobile-submenu">
                    <li>
                      <router-link to="/reports/dashboard" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Dashboard</span>
                      </router-link>
          </li>
                    <li>
                      <router-link to="/reports" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>Тайлан удирдах</span>
                      </router-link>
          </li>
                    <li v-for="report in reports" :key="report.id">
                      <router-link :to="`/reports/${report.id}`" class="mobile-submenu-item" @click="sidebarOpen = false">
                        <span class="submenu-dot"></span>
                        <span>{{ report.name }}</span>
                      </router-link>
          </li>
                  </ul>
                </transition>
          </li>

              <!-- Гарах товч -->
              <li class="nav-divider"></li>
              <li>
                <a @click="logout" class="mobile-nav-item nav-item-logout">
                  <span class="nav-icon">
                    <font-awesome-icon icon="right-from-bracket" />
                  </span>
                  <span class="nav-text">Гарах</span>
                </a>
          </li>
        </ul>
          </nav>
        </div>
      </el-drawer>

      <!-- Desktop Sidebar (Always Visible) -->
      <aside class="sidebar-container">
        <!-- Sidebar Header -->
        <div class="sidebar-header">
          <div class="logo-section">
            <div class="logo-icon">
              <font-awesome-icon icon="chart-line" />
            </div>
            <h2 class="logo-text">Sky Cargo</h2>
          </div>
        </div>

        <!-- Navigation Menu -->
        <nav class="sidebar-nav">
          <ul class="nav-list">
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="chart-line" />
                </span>
                <span class="nav-text">Дашбоард</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/users" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="users" />
                </span>
                <span class="nav-text">Хэрэглэгч</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/banners" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="bullhorn" />
                </span>
                <span class="nav-text">Суртчилгаа</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/faqs" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="question-circle" />
                </span>
                <span class="nav-text">Түгээмэл асуулт</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/trackCodes" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="barcode" />
                </span>
                <span class="nav-text">Track Code</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/worker" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="user-tie" />
                </span>
                <span class="nav-text">Ажилтан</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/message" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="envelope" />
                </span>
                <span class="nav-text">Мессеж</span>
            </router-link>
          </li>
            <li v-if="checkPermissionsPage('admin')">
              <router-link to="/messageHistory" class="nav-item">
                <span class="nav-icon">
                  <font-awesome-icon icon="clock-rotate-left" />
                </span>
                <span class="nav-text">Мессеж түүх</span>
            </router-link>
          </li>
          <!-- Зардал цэс -->
            <li v-if="checkPermissionsPage('admin')" class="nav-group">
              <div
                @click="showCostSubmenu = !showCostSubmenu"
                class="nav-item nav-item-group"
                :class="{ 'nav-item-active': isCostRoute || showCostSubmenu }"
              >
                <span class="nav-icon">
                  <font-awesome-icon icon="dollar-sign" />
                </span>
                <span class="nav-text">Зардал</span>
                <span class="nav-arrow">
                  <font-awesome-icon
                    :icon="showCostSubmenu ? 'chevron-down' : 'chevron-right'"
                    class="transition-transform duration-200"
                  />
                </span>
            </div>

              <!-- Дэд цэс - Dynamic зардлын төрлүүд -->
              <transition name="slide-fade">
                <ul v-show="showCostSubmenu" class="submenu">
                  <li>
                    <router-link to="/costs" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Бүх зардал</span>
                </router-link>
              </li>
                  <li>
                    <router-link to="/costTypes" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Зардлын төрөл удирдах</span>
                </router-link>
              </li>
                  <li>
                    <router-link to="/costs/transfer" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Салбар хооронд шилжүүлэлт</span>
                </router-link>
              </li>
                  <li>
                    <router-link to="/costs/deliveries" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Хүргэлт</span>
                </router-link>
              </li>
                  <li v-for="costType in costTypes" :key="costType.id">
                    <router-link :to="`/costs/${costType.id}`" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>{{ costType.name }}</span>
                </router-link>
              </li>
            </ul>
              </transition>
            </li>

          <!-- Тайлан цэс -->
            <li v-if="checkPermissionsPage('admin')" class="nav-group">
              <div
                @click="showReportSubmenu = !showReportSubmenu"
                class="nav-item nav-item-group"
                :class="{ 'nav-item-active': isReportRoute || showReportSubmenu }"
              >
                <span class="nav-icon">
                  <font-awesome-icon icon="chart-pie" />
                </span>
                <span class="nav-text">Тайлан</span>
                <span class="nav-arrow">
                  <font-awesome-icon
                    :icon="showReportSubmenu ? 'chevron-down' : 'chevron-right'"
                    class="transition-transform duration-200"
                  />
                </span>
            </div>

              <!-- Дэд цэс - Dynamic тайлангууд -->
              <transition name="slide-fade">
                <ul v-show="showReportSubmenu" class="submenu">
                  <li>
                    <router-link to="/reports/dashboard" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Dashboard</span>
                </router-link>
              </li>
                  <li>
                    <router-link to="/reports" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>Тайлан удирдах</span>
                </router-link>
              </li>
                  <li v-for="report in reports" :key="report.id">
                    <router-link :to="`/reports/${report.id}`" class="submenu-item">
                      <span class="submenu-dot"></span>
                      <span>{{ report.name }}</span>
                </router-link>
              </li>
            </ul>
              </transition>
            </li>

            <!-- Гарах товч -->
            <li class="nav-divider"></li>
            <li>
              <a @click="logout" class="nav-item nav-item-logout">
                <span class="nav-icon">
                  <font-awesome-icon icon="right-from-bracket" />
                </span>
                <span class="nav-text">Гарах</span>
              </a>
          </li>
        </ul>
        </nav>
      </aside>
    </div>
  </template>

<script>
import {
  checkPermissions
} from '@/helpers/custom'
import services from '@/services'

export default {
  name: 'DashboardPage',
  data () {
    return {
      sidebarOpen: false,
      showReportSubmenu: false,
      showCostSubmenu: false,
      reports: [],
      costTypes: []
    }
  },
  computed: {
    isReportRoute () {
      return this.$route.path.startsWith('/reports')
    },
    isCostRoute () {
      return this.$route.path.startsWith('/costs')
    }
  },
  created () {
    this.loadReports()
    this.loadCostTypes()
  },
  watch: {
    '$route' () {
      // Route өөрчлөгдөхөд mobile drawer хаах
      if (this.sidebarOpen) {
        this.sidebarOpen = false
      }
      // Тайлан route дээр байвал submenu нээх
      if (this.isReportRoute) {
        this.showReportSubmenu = true
      }
      // Зардал route дээр байвал submenu нээх
      if (this.isCostRoute) {
        this.showCostSubmenu = true
      }
    }
  },
  methods: {
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    // Toggle sidebar open and close
    toggleSidebar () {
      this.sidebarOpen = !this.sidebarOpen
    },
    async loadReports () {
      try {
        const response = await services.get('reports')
        if (response && response.type === 'success') {
          this.reports = response.data || []
        }
      } catch (error) {
        console.error('Error loading reports:', error)
        // Алдаа гарвал хоосон массив үлдээх
        this.reports = []
      }
    },
    async loadCostTypes () {
      try {
        const response = await services.get('costTypes')
        if (response && response.type === 'success') {
          this.costTypes = response.data || []
        } else if (response && response.data) {
          // Хэрэв response.data шууд массив байвал
          this.costTypes = response.data || []
        }
      } catch (error) {
        console.error('Error loading cost types:', error)
        // Алдаа гарвал хоосон массив үлдээх
        this.costTypes = []
      }
    },
    logout () {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>

  <style scoped>
/* Sidebar Container */
.sidebar-container {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-container::-webkit-scrollbar {
  width: 6px;
}

.sidebar-container::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Sidebar Header */
.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin: 0;
  letter-spacing: 0.5px;
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  padding: 16px 12px;
  overflow-y: auto;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-list > li {
  margin-bottom: 4px;
}

/* Nav Item */
.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  gap: 12px;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateX(4px);
}

.nav-item.router-link-active,
.nav-item-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  font-weight: 600;
}

.nav-item.router-link-active::before,
.nav-item-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 60%;
  background: white;
  border-radius: 0 4px 4px 0;
}

.nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.nav-text {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
}

/* Nav Group */
.nav-group {
  position: relative;
}

.nav-item-group {
  justify-content: space-between;
}

.nav-arrow {
  font-size: 12px;
  transition: transform 0.3s ease;
}

/* Submenu */
.submenu {
  list-style: none;
  padding: 8px 0 8px 0;
  margin: 4px 0 0 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.submenu li {
  margin: 0;
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 48px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  gap: 10px;
  font-size: 13px;
}

.submenu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  padding-left: 52px;
}

.submenu-item.router-link-active,
.submenu-item-active {
  background: rgba(102, 126, 234, 0.2);
  color: white;
  font-weight: 600;
}

.submenu-dot {
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  flex-shrink: 0;
}

.submenu-item.router-link-active .submenu-dot,
.submenu-item-active .submenu-dot {
  background: white;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

/* Nav Divider */
.nav-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 12px 16px;
  list-style: none;
}

/* Logout Item */
.nav-item-logout {
  color: rgba(255, 107, 107, 0.8);
}

.nav-item-logout:hover {
  background: rgba(255, 107, 107, 0.2);
  color: #ff6b6b;
}

/* Animations */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Mobile Menu Button */
.mobile-menu-button {
  display: none;
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1001;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-menu-button:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.mobile-menu-button:active {
  transform: scale(0.95);
}

/* Mobile Sidebar Content */
.mobile-sidebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
}

.mobile-sidebar-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
}

.mobile-sidebar-nav {
  flex: 1;
  padding: 16px 12px;
  overflow-y: auto;
}

.mobile-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-nav-list > li {
  margin-bottom: 4px;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  gap: 12px;
}

.mobile-nav-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.mobile-nav-item.router-link-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  font-weight: 600;
}

.mobile-submenu {
  list-style: none;
  padding: 8px 0 8px 0;
  margin: 4px 0 0 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.mobile-submenu li {
  margin: 0;
}

.mobile-submenu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 48px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  gap: 10px;
  font-size: 13px;
}

.mobile-submenu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.mobile-submenu-item.router-link-active {
  background: rgba(102, 126, 234, 0.2);
  color: white;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 1023px) {
  .sidebar-container {
      display: none;
    }

  .mobile-menu-button {
    display: flex;
  }
}

@media (min-width: 1024px) {
  .mobile-menu-button {
    display: none !important;
  }

  .mobile-drawer {
    display: none !important;
  }
}

/* Mobile Drawer Styles */
:deep(.mobile-drawer) {
  background: transparent;
}

:deep(.mobile-drawer .el-drawer__body) {
  padding: 0;
  overflow: hidden;
}

:deep(.mobile-drawer .el-drawer__header) {
  display: none;
  }
  </style>
